import { cn } from '@Pages/pageRuntime/lib/utils';
import * as React from 'react';

const AlertTitle = ({
  className,
  children,
  ref,
  ...props
}: React.HTMLAttributes<HTMLHeadingElement> & { ref?: React.Ref<HTMLParagraphElement> }) => (
  <h5 ref={ref} className={cn('mb-3 leading-5 font-medium tracking-tight', className)} {...props}>
    {children}
  </h5>
);
AlertTitle.displayName = 'AlertTitle';

export { AlertTitle };
